import React, { useState, useRef, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Snackbar from "../../../common/snackbar/components/snackbar";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Footer from "../../Home/components/footer";
import Nav_bar from "../../Home/Container/navCon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
const CustomQRCode = (props) => {
  const [openLogin, setOpenLogin] = useState(true);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [qrValue, setQrValue] = useState("");
  const [qrSize, setQrSize] = useState(300);
  const [fgColor, setFgColor] = useState("#FFFFFF");
  const [bgColor, setBgColor] = useState("#000000");
  const [eyeColor, setEyeColor] = useState([
    { outer: "#FFFFFF", inner: "#FFFFFF" },
    { outer: "#FFFFFF", inner: "#FFFFFF" },
    { outer: "#FFFFFF", inner: "#FFFFFF" },
  ]);
  const [eyeRadius, setEyeRadius] = useState([
    { outer: 5, inner: 5 },
    { outer: 5, inner: 5 },
    { outer: 5, inner: 5 },
  ]);
  const [qrStyle, setQrStyle] = useState("squares");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoWidth, setLogoWidth] = useState(50);
  const [logoHeight, setLogoHeight] = useState(50);
  const [clearLogoBg, setClearLogoBg] = useState(false);
  const [uniqueId] = useState(uuidv4());
  const [format, setFormat] = useState("");
  const [quality, setQuality] = useState("");
  const [qrType, setQrType] = useState("");
  const [redirectlink, setRedirectlink] = useState("");
  const qrCodeRef = useRef(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const nameRef = useRef();
  const linkRef = useRef();
  const handlePrintRef = useRef();
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => setLogoUrl(reader.result);
    reader.readAsDataURL(file);
  };
  const handleKeyPress = (event) => {
    // Check if "Enter" key is pressed
    if (event.key === "Enter") {
      handlePrint();
    }
  };
  const handlePrint = async () => {
    if (!qrCodeRef.current) return;
    setIsSubmitted(true);
    if (name === "" || link === "") {
      alert("Both name and link are required.");
      return; // Exit early if validation fails
    }
    setTimeout(async () => {
      const canvas = await html2canvas(qrCodeRef.current);
      const imageUrl = canvas.toDataURL("image/png");

      // Prepare payload with QR code data and user information
      const payload = {
        addedBy: props.login.user_id,
        qr_id: uniqueId,
        name,
        email,
        link,
        qrCodeBase64: imageUrl,
        qrType,
        qrSize,
        fgColor,
        bgColor,
        eyeColor,
        eyeRadius,
        qrStyle,
        logoUrl,
        logoWidth,
        logoHeight,
        clearLogoBg,
        format,
        quality,
        redirectlink,
      };

      try {
        // Send QR data to the backend
        const response = await axios.post(
          "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/register",
          // "http://localhost:7002/qrcode/register",
          payload,
          {
            headers: {
              token: `${props.login.token}`,
            },
          }
        );
        const responseData = response.data.data.qrCode;

        // Update QR link
        props.updatesQrLink(
          props.login.token,
          props.login.user_id,
          responseData._id,
          redirectlink
        );

        // Automatically trigger QR code download
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = `${name || "QRCode"}.png`; // File name for download
        link.click();

        // Navigate to QR code page after download
        navigate("/qrcode");
      } catch (error) {
        console.error("Error saving QR code data to the backend:", error);
        alert("Failed to save QR code data to the backend.");
      }
    }, 100);
  };

  const generateQrValue = () => {
    setQrValue(link);
  };

  const downloadQRCode = async (format) => {
    generateQrValue();

    if (!qrCodeRef.current) return;

    setTimeout(async () => {
      const canvas = await html2canvas(qrCodeRef.current);
      const imageUrl = canvas.toDataURL(`image/${format}`);
      // Create a payload with the QR code data and user information
      const payload = {
        addedBy: props.login.user_id, // Assuming you have the user ID
        qr_id: uniqueId, // The unique identifier for the QR code
        name, // Name entered by the user
        email, // Email entered by the user
        link, // The link embedded in the QR code
        qrCodeBase64: imageUrl,
        qrType, // The base64 string of the QR code image
      };

      try {
        // Send the QR code data to the backend
        const response = await axios.post(
          "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/register",
          // "http://localhost:7001/qrcode/register",
          payload,
          {
            headers: {
              token: `${props.login.token}`, // Include token if needed
            },
          }
        );
        const responseData = response.data.data.qrCode;

        props.updatesQrLink(
          props.login.token,
          props.login.user_id,
          responseData._id,
          redirectlink
        );
        // If the backend call is successful, trigger the download
        const linkElement = document.createElement("a");
        linkElement.href = imageUrl;
        linkElement.download = `qrcode.${format}`;
        linkElement.click();
        navigate("/qrcode");
      } catch (error) {
        console.error("Error saving QR code data to the backend:", error);
        alert("Failed to save QR code data to the backend.");
      }
    }, 100);
  };
  useEffect(() => {
    if (qrType === "Dynamic") {
      // Generate a unique number using Date.now()
      const uniqueNumber = Date.now();
      setLink(`https://qr.tapx.digital/${uniqueNumber}`);
    } else {
      setLink(""); // Clear the link for Static QR Type
    }
  }, [qrType]);

  const handleChangeFormat = (event) => {
    setFormat(event.target.value);
    if (event.target.value) downloadQRCode(event.target.value);
  };

  const handleChangeQuality = (event) => {
    setQuality(event.target.value);
  };

  return (
    <Box>
      <Nav_bar />

      <Box
        sx={{
          minHeight: "60vh",
          padding: "20px",
          backgroundImage:
            "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREqHQAhLVZ47Xyenj89hwLtgCHK_lGaEODMcAM741unQeyHEPD8rDUycMpi2hVyl4OkKE&usqp=CAU)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}>
        {/* <Snackbar
          open={this.props.snackbar?.response_received}
          close_snack_bar={this.props.close_snack_bar}
          message={this.props.snackbar?.message}
        /> */}
        <Link style={{ direction: "none" }} to="/qrcode">
          {" "}
          <Button variant="contained" color="secondary">
            <ArrowBackIcon /> Back
          </Button>
        </Link>
        <Grid
          container
          spacing={3}
          sx={{ maxWidth: 1200, margin: "auto", p: 2 }}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardHeader title="Fill the Form & Generate Your Custom QR Code Instantly" />
              <CardContent sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={
                        <span>
                          Full Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="outlined"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      fullWidth
                      error={isSubmitted && !name} // Shows error if name is empty and form is submitted
                      helperText={
                        isSubmitted && !name ? "Full Name is required" : ""
                      }
                      onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Email ID"
                      variant="outlined"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  {qrType === "Static" ? (
                    <Grid item xs={12}>
                      <TextField
                        label="Link"
                        variant="outlined"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        fullWidth
                        error={isSubmitted && !link} // Shows error if name is empty and form is submitted
                        helperText={
                          isSubmitted && !link ? "Link is required" : ""
                        }
                        onKeyDown={handleKeyPress}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <TextField
                        label={
                          <span>
                            Link <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        variant="outlined"
                        value={redirectlink}
                        onChange={(e) => setRedirectlink(e.target.value)}
                        fullWidth
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextField
                      label="QR Code Size"
                      variant="outlined"
                      type="number"
                      value={qrSize}
                      onChange={(e) => setQrSize(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Foreground Color"
                      variant="outlined"
                      type="color"
                      value={fgColor}
                      onChange={(e) => setFgColor(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Background Color"
                      variant="outlined"
                      type="color"
                      value={bgColor}
                      onChange={(e) => setBgColor(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Outer Color"
                      variant="outlined"
                      type="color"
                      value={eyeColor[0].outer}
                      onChange={(e) =>
                        setEyeColor([
                          { ...eyeColor[0], outer: e.target.value },
                          { ...eyeColor[1], outer: e.target.value },
                          { ...eyeColor[2], outer: e.target.value },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Inner Color"
                      variant="outlined"
                      type="color"
                      value={eyeColor[0].inner}
                      onChange={(e) =>
                        setEyeColor([
                          { ...eyeColor[0], inner: e.target.value },
                          { ...eyeColor[1], inner: e.target.value },
                          { ...eyeColor[2], inner: e.target.value },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Outer Radius"
                      variant="outlined"
                      type="number"
                      value={eyeRadius[0].outer}
                      onChange={(e) =>
                        setEyeRadius([
                          { ...eyeRadius[0], outer: Number(e.target.value) },
                          { ...eyeRadius[1], outer: Number(e.target.value) },
                          { ...eyeRadius[2], outer: Number(e.target.value) },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Inner Radius"
                      variant="outlined"
                      type="number"
                      value={eyeRadius[0].inner}
                      onChange={(e) =>
                        setEyeRadius([
                          { ...eyeRadius[0], inner: Number(e.target.value) },
                          { ...eyeRadius[1], inner: Number(e.target.value) },
                          { ...eyeRadius[2], inner: Number(e.target.value) },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="QR Style"
                      variant="outlined"
                      select
                      value={qrStyle}
                      onChange={(e) => setQrStyle(e.target.value)}
                      fullWidth>
                      <MenuItem value="squares">Squares</MenuItem>
                      <MenuItem value="dots">Dots</MenuItem>
                      <MenuItem value="rounded">Rounded</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={clearLogoBg}
                          onChange={(e) => setClearLogoBg(e.target.checked)}
                        />
                      }
                      label="Clear Logo Background"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Button variant="outlined" component="label" fullWidth>
                          Upload Logo
                          <input type="file" hidden onChange={handleLogoUpload} />
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          variant="outlined"
                          onClick={() => setLogoUrl("")}
                          fullWidth
                        >
                          Remove Logo
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>


                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Logo Width"
                      variant="outlined"
                      type="number"
                      value={logoWidth}
                      onChange={(e) => setLogoWidth(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Logo Height"
                      variant="outlined"
                      type="number"
                      value={logoHeight}
                      onChange={(e) => setLogoHeight(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {link !== "" && (
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <CardHeader title="Your QR Code" />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <Box id="qr-code" ref={qrCodeRef}>
                      <QRCode
                        value={link}
                        size={qrSize}
                        ecLevel="M"
                        eyeRadius={eyeRadius}
                        eyeColor={eyeColor}
                        qrStyle={qrStyle}
                        fgColor={fgColor}
                        bgColor={bgColor}
                        quietZone={10}
                        logoImage={logoUrl}
                        logoWidth={logoWidth}
                        logoHeight={logoHeight}
                        removeQrCodeBehindLogo={clearLogoBg}
                      />
                    </Box>
                    {/* <Box sx={{ display: "flex", gap: 2 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadIcon />}
                        onClick={() => downloadQRCode("png")}>
                        Download as PNG
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadIcon />}
                        onClick={() => downloadQRCode("jpg")}>
                        Download as JPG
                      </Button>
                    </Box> */}
                    {/* <FormControl fullWidth>
                      <InputLabel>Download Quality</InputLabel>
                      <Select value={quality} onChange={handleChangeQuality}>
                        <MenuItem value={10}>Full HD (1080p)</MenuItem>
                        <MenuItem value={20}>High (720p)</MenuItem>
                        <MenuItem value={30}>Medium (360p)</MenuItem>
                        <MenuItem value={40}>Low (144p)</MenuItem>
                      </Select>
                    </FormControl> */}
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handlePrint}
                      ref={handlePrintRef}>
                      Save Qr Code
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>

      <Dialog
        open={openLogin}
        // onClose={handleClose}
        maxWidth="xs"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(5px)",
          },
        }}>
        <Box
          sx={{
            padding: "50px",
            borderRadius: "10px",
            backgroundColor: "white",
          }}>
          <Link to="/qrcode">
            <IconButton
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                color: "black",
              }}>
              <CloseIcon />
            </IconButton>
          </Link>
          <Typography
            variant="h6"
            component="div"
            style={{
              color: "black",
              textAlign: "center",
              fontFamily: "serif",
              wordSpacing: "1px",
              fontSize: "30px",
            }}>
            Please Choose Qr Type
          </Typography>
          {/* <Typography
      variant="body1"
      component="div"
      style={{ color: "grey", textAlign: "center" }}
    >
      
    </Typography> */}
          {/* <form onSubmit={handleSubmit}> */}
          <FormControl
            component="fieldset"
            sx={{ color: "white", marginTop: "20px" }}>
            <RadioGroup
              aria-label="login-options"
              name="login-options"
              value={qrType}
              onChange={(e) => setQrType(e.target.value)}
              sx={{
                "& .MuiFormControlLabel-label": { color: "black" },
              }}>
              <FormControlLabel
                value="Static"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label="Static"
              />
              <FormControlLabel
                value="Dynamic"
                control={
                  <Radio
                    sx={{
                      color: "black",
                      "&.Mui-checked": { color: "black" },
                    }}
                  />
                }
                label="Dynamic"
              />
            </RadioGroup>
          </FormControl>
          <Button
            // type="submit"
            variant="outlined"
            fullWidth
            style={{
              marginTop: "20px",
              backgroundColor: "#5766FE",
              color: "white",
              padding: "10px",
            }}
            onClick={(e) => {
              setOpenLogin(false);
            }}>
            Continue
          </Button>
          {/* </form> */}
        </Box>
      </Dialog>

      <Footer />
    </Box>
  );
};

export default CustomQRCode;
